import { IMAGES } from "../../config/landingConfig";
import { Reveal } from "./Reveal";
import { SectionTag } from "./decorations";
import { PhotoSlot } from "./PhotoSlot";

export const About = () => (
  <section
    id="o-prowadzacej"
    data-testid="about-section"
    className="scroll-mt-24 border-y-4 border-ink bg-white"
  >
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 py-20 sm:px-6 lg:grid-cols-[0.9fr_1.1fr] lg:py-28">
      <Reveal className="relative mx-auto w-full max-w-md lg:max-w-none">
        <div className="float-soft absolute -right-5 -top-6 z-10 h-12 w-12 rotate-12 rounded-2xl border-2 border-ink bg-cyan shadow-hard-sm" aria-hidden="true" />
        <PhotoSlot
          src={IMAGES.about}
          alt="Anna Popławska - nauczycielka języka angielskiego i trenerka nauczycieli"
          slotLabel="o prowadzącej"
          className="aspect-[4/5] w-full -rotate-2 rounded-[2rem] border-4 border-ink bg-white shadow-hard-lg"
          imgClassName="object-top"
        />
        <span
          className="font-display absolute -bottom-5 right-6 rotate-2 rounded-full border-2 border-ink bg-cyan px-5 py-2 text-sm uppercase tracking-wide text-ink shadow-hard-sm"
        >
          5000+ przeszkolonych nauczycieli
        </span>
      </Reveal>

      <div>
        <Reveal>
          <SectionTag number="10" label="O prowadzącej" color="bg-cyan" />
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 text-2xl font-extrabold tracking-tight text-ink sm:text-3xl lg:text-4xl">
            Twój kurs prowadzi <span className="marker-cyan">Anna Popławska</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 text-base leading-relaxed text-ink/80 sm:text-lg">
            Anna Popławska jest nauczycielką języka angielskiego, trenerką nauczycieli
            i twórczynią nowoczesnych materiałów edukacyjnych. Od ponad 17 lat uczy,
            a od około 14 lat szkoli nauczycieli. W jej szkoleniach wzięło udział
            ponad 5000 osób.
          </p>
          <p className="mt-4 text-base leading-relaxed text-ink/80 sm:text-lg">
            Łączy metodykę nauczania języków obcych z nowymi technologiami
            i praktycznym wykorzystaniem sztucznej inteligencji. Pokazuje nie tylko
            narzędzia, ale przede wszystkim sposób myślenia, dzięki któremu technologia
            rzeczywiście wspiera nauczyciela i ucznia.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <ul className="mt-8 flex flex-wrap gap-3" aria-label="Doświadczenie Anny Popławskiej">
            <li className="rounded-full border-2 border-ink bg-cyan px-4 py-2 text-xs font-extrabold uppercase tracking-wide text-ink shadow-hard-sm">
              17+ lat w nauczaniu
            </li>
            <li className="rounded-full border-2 border-ink bg-magenta px-4 py-2 text-xs font-extrabold uppercase tracking-wide text-white shadow-hard-sm">
              ~14 lat szkoleń dla nauczycieli
            </li>
            <li className="rounded-full border-2 border-ink bg-violet px-4 py-2 text-xs font-extrabold uppercase tracking-wide text-white shadow-hard-sm">
              Trenerka nauczycieli
            </li>
          </ul>
        </Reveal>
      </div>
    </div>
  </section>
);
